import { useSearchParams } from "react-router-dom";

export default function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const topic = searchParams.get("topic");

  return (
    <div className="flex items-center justify-center text-center p-4">
      <div className="text-xl font-medium">
        You have successfully unsubscribed
        {topic && (
          <> from <span className="font-bold">{topic}</span></>
        )}
        !
      </div>
    </div>
  );
}
